<div class="form-config-container">
  <form nz-form #formRef="ngForm">
    <!-- 表单布局 -->
    <nz-form-item>
      <nz-form-label [nzSpan]="12">表单布局</nz-form-label>
      <nz-form-control>
        <nz-select #formLayoutInput="ngModel" name="formLayout" [(ngModel)]="data.formLayout">
          <nz-option nzLabel="水平" nzValue="horizontal"></nz-option>
          <nz-option nzLabel="垂直" nzValue="vertical"></nz-option>
          <nz-option nzLabel="行内" nzValue="inline"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- 表单内组件尺寸 -->
    <nz-form-item>
      <nz-form-label [nzSpan]="12">组件尺寸</nz-form-label>
      <nz-form-control>
        <nz-select #formSizeInput="ngModel" name="formSize" [(ngModel)]="data.formSize">
          <nz-option nzLabel="默认" nzValue="default"></nz-option>
          <nz-option nzLabel="大" nzValue="large"></nz-option>
          <nz-option nzLabel="小" nzValue="small"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- 显示按钮 -->
    <nz-form-item>
      <nz-form-label [nzSpan]="12">显示按钮</nz-form-label>
      <nz-form-control>
        <nz-switch #formBtnInput="ngModel" name="formBtn" [(ngModel)]="data.formBtn"></nz-switch>
      </nz-form-control>
    </nz-form-item>

    <!-- 显示提交按钮 -->
    <nz-form-item *ngIf="data.formBtn">
      <nz-form-label [nzSpan]="12">显示提交按钮</nz-form-label>
      <nz-form-control>
        <nz-switch #formBtnSubmitInput="ngModel" name="formBtnSubmit" [(ngModel)]="data.formBtnSubmit"></nz-switch>
      </nz-form-control>
    </nz-form-item>

    <!-- 提交按钮文本 -->
    <nz-form-item *ngIf="data.formBtn && data.formBtnSubmit">
      <nz-form-label [nzSpan]="12">提交按钮文本</nz-form-label>
      <nz-form-control>
        <input nz-input #formBtnSubmitTextInput="ngModel" name="formBtnSubmitText" type="text" [(ngModel)]="data.formBtnSubmitText" />
      </nz-form-control>
    </nz-form-item>

    <!-- 显示重置按钮 -->
    <nz-form-item *ngIf="data.formBtn">
      <nz-form-label [nzSpan]="12">显示重置按钮</nz-form-label>
      <nz-form-control>
        <nz-switch #formBtnResetInput="ngModel" name="formBtnReset" [(ngModel)]="data.formBtnReset"></nz-switch>
      </nz-form-control>
    </nz-form-item>

    <!-- 重置按钮文本 -->
    <nz-form-item *ngIf="data.formBtn && data.formBtnReset">
      <nz-form-label [nzSpan]="12">重置按钮文本</nz-form-label>
      <nz-form-control>
        <input nz-input #formBtnResetText="ngModel" name="formBtnResetText" type="text" [(ngModel)]="data.formBtnResetText" />
      </nz-form-control>
    </nz-form-item>

    <!-- 表单样式模版 -->
    <nz-form-item>
      <nz-form-label [nzSpan]="12">表格样式</nz-form-label>
      <nz-form-control>
        <nz-switch #formBtnInput="ngModel" name="bordered" [ngModel]="bordered" (ngModelChange)="borderedChange($event)"></nz-switch>
      </nz-form-control>
    </nz-form-item>
  </form>
</div>
